import React from 'react';

import { flagStyles } from '../settings';

const SvgFK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1680px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFK;
